import { getQueryParameter } from '../location';

import { MetaOsHubHostName } from './host';

type HasMetaOsHostNameInContentUrl = () => boolean;
export const hasMetaOsHostNameInContentUrl: HasMetaOsHostNameInContentUrl = () => {
  const queryParameterValue = getQueryParameter('hostappname');
  if (queryParameterValue === undefined || queryParameterValue === '' || Array.isArray(queryParameterValue)) {
    return false;
  }

  return Object.values(MetaOsHubHostName).includes(queryParameterValue as MetaOsHubHostName);
};
